import { tag, } from '@tunarr/types';
export { ApiProgramMinter } from './services/ApiProgramMinter.js';
export { mod as dayjsMod } from './util/dayjsExtensions.js';
// TODO replace first arg with shared type
export function createExternalId(sourceType, //StrictExclude<ExternalIdType, SingleExternalIdType>,
sourceId, itemId) {
    return `${sourceType}|${sourceId}|${itemId}`;
}
export function createGlobalExternalIdString(sourceType, id) {
    return `${sourceType}|${id}`;
}
export function createExternalIdFromMulti(multi) {
    return createExternalId(multi.source, tag(multi.sourceId), multi.id);
}
export function createExternalIdFromGlobal(global) {
    return createGlobalExternalIdString(global.source, global.id);
}
// We could type this better if we reuse the other ExternalId
// types in createExternalId
export function containsMultiExternalId(ids, targetId) {
    for (const id of ids) {
        if (id.type === 'single') {
            continue;
        }
        if (createExternalId(id.source, tag(id.sourceId), id.id) === targetId) {
            return id;
        }
    }
    return null;
}
//# sourceMappingURL=index.js.map